/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Stat_FirstpassInputs */

const en_fw_bm_stat_firstpass = /** @type {(inputs: Fw_Bm_Stat_FirstpassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First-pass rate`)
};

const id_fw_bm_stat_firstpass = /** @type {(inputs: Fw_Bm_Stat_FirstpassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lolos percobaan pertama`)
};

/**
* | output |
* | --- |
* | "First-pass rate" |
*
* @param {Fw_Bm_Stat_FirstpassInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_stat_firstpass = /** @type {((inputs?: Fw_Bm_Stat_FirstpassInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Stat_FirstpassInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_stat_firstpass(inputs)
	return en_fw_bm_stat_firstpass(inputs)
});